"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.importUnitsReducer = exports.updateUnitsReducer = exports.createUnitsReducer = exports.fetchUnitsReducer = exports.importUnitsSlice = exports.updateUnitsSlice = exports.createUnitsSlice = exports.fetchUnitsSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const unitsAction_1 = require("./unitsAction");
const fetchInitialState = {
    loading: false,
    error: null,
    data: []
};
const createInitialState = {
    loading: false,
    error: null,
    data: []
};
const updateInitialState = {
    loading: false,
    error: null,
    data: []
};
const importInitialState = {
    loading: false,
    error: null,
    data: []
};
exports.fetchUnitsSlice = (0, toolkit_1.createSlice)({
    name: 'units/fetch',
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(unitsAction_1.fetch.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(unitsAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(unitsAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.createUnitsSlice = (0, toolkit_1.createSlice)({
    name: 'units/create',
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(unitsAction_1.create.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(unitsAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(unitsAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.updateUnitsSlice = (0, toolkit_1.createSlice)({
    name: 'units/update',
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(unitsAction_1.update.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(unitsAction_1.update.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(unitsAction_1.update.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.importUnitsSlice = (0, toolkit_1.createSlice)({
    name: 'units/import',
    initialState: importInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(unitsAction_1.importUnits.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(unitsAction_1.importUnits.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(unitsAction_1.importUnits.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.fetchUnitsReducer = exports.fetchUnitsSlice.reducer;
exports.createUnitsReducer = exports.createUnitsSlice.reducer;
exports.updateUnitsReducer = exports.updateUnitsSlice.reducer;
exports.importUnitsReducer = exports.importUnitsSlice.reducer;
